/**
 * Utilitários compartilhados pelos componentes do Chat.
 * Centraliza helpers que serão usados pelas múltiplas seções extraídas.
 */
export { formatLastMessage } from '../../utils/lastMessagePreview.ts';
export type { LastMessagePreview } from '../../utils/lastMessagePreview.ts';

export const getInitials = (name: string): string => {
  if (!name || name.startsWith('+') || /^\d+$/.test(name.substring(0, 2))) {
    return 'CT';
  }

  const parts = name.split(' ').filter(part => part.length > 0);

  if (parts.length === 0) return 'CT';

  if (parts.length === 1) {
    return parts[0].substring(0, 2).toUpperCase();
  }

  return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
};

export const getDefaultAvatar = (phone: string): string => {
  return `https://ui-avatars.com/api/?name=${phone}&background=random`;
};
